import _ from "lodash";
import { useEffect, useState } from "react";
import { Dropdown, DropdownItemProps, Form, Input } from "semantic-ui-react";
import { MeasurementData, UpdateLimitResultFilters } from "../../models/update_limit_model";
import { fieldError } from "../../utils";

export function FilterEditor(props: { value: UpdateLimitResultFilters, measurement_key: string, measurements: MeasurementData[], invalidError: any, onChange: (value: UpdateLimitResultFilters) => void }) {
    const { value, measurements, measurement_key, invalidError, onChange } = props;
    const [orderOptions, setOrderOptions] = useState<DropdownItemProps[]>([]);

    useEffect(() => {
        const allOrders = measurements.filter(m => measurement_key == [m.measurement_name, m.export_file_name].join('_le-witt_')).map(m => m.order)
        const uniqueOrder = _.uniq(allOrders);
        setOrderOptions([{ key: '', text: 'All', value: '' }, ...uniqueOrder.map(o => ({ key: o, text: o, value: o }))]);
        if (!uniqueOrder.includes(value.order)) {
            onChange({ ...value, order: '' });
        }
    }, [measurements]);

    const unitFilterStatuses: DropdownItemProps[] = [
        { text: 'Pass', value: 1, key: 1 },
        { text: 'Fail', value: 2, key: 2 },
        { text: 'Invalid', value: 3, key: 3 }
    ];

    const measurementFilterStatuses: DropdownItemProps[] = [
        { text: 'Pass', value: 1, key: 1 },
        { text: 'Fail', value: 2, key: 2 }
    ];

    return <>
        <Form.Group widths="equal">
            <Form.Input label="Order (Build)" error={fieldError('order', invalidError)}>
                <Dropdown name="order" value={value.order || ''} onChange={(e, v) => onChange({ ...value, order: v.value as string })} options={orderOptions} search selection></Dropdown>
            </Form.Input>
            <Form.Input label="Measurement Status" error={fieldError('measurement_status', invalidError)}>
                <Dropdown multiple name="measurement_status" value={value.measurement_status || []} onChange={(e, v) => onChange({ ...value, measurement_status: v.value as number[] })} options={measurementFilterStatuses} search selection></Dropdown>
            </Form.Input>
            <Form.Input label="Sequence Status" error={fieldError('sequence_status', invalidError)}>
                <Dropdown multiple name="sequence_status" value={value.sequence_status || []} onChange={(e, v) => onChange({ ...value, sequence_status: v.value as number[] })} options={unitFilterStatuses} search selection></Dropdown>
            </Form.Input>
        </Form.Group>
    </>
}